import { FC } from 'react'
import DesktopNavigation from 'components/DesktopNavigation'
import { UserProtectedRoute } from 'routes'

const HelpTechnicalPackagesPage: FC = () => {
  return (
    <UserProtectedRoute>
      <DesktopNavigation label='Pakiety techniczne' />
    </UserProtectedRoute>
  )
}

export default HelpTechnicalPackagesPage
